import { useMemo, useState } from 'react';
import { paginationDefaultValues } from './constants';
import { PaginationDefaultValue } from './types';
export const usePagination = (limit) => {
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(limit ? paginationDefaultValues[limit] : paginationDefaultValues[PaginationDefaultValue.LG]);
    return useMemo(() => ({
        page,
        setPage,
        perPage,
        setPerPage,
    }), [page, perPage]);
};
